import { Component } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { TabSideBaseClass } from "src/app/common/tab-side/tab-side.component";
import { Tabs } from "src/app/common/tabs/tabs.enum";
import { TabsService } from "src/app/common/tabs/tabs.service";
import {KoblingerService, OppdragLeverandor, OppdragSystem} from "src/app/koblinger/koblinger.service";
import { ModalService } from "src/app/services/modal.service";
import { TilgangService } from "src/app/services/tilgang.service";


@Component({
  selector: "app-leverandoroppdrag-tab",
  templateUrl: "./leverandoroppdrag-tab.component.html"
})
export class LeverandorOppdragTabComponent extends TabSideBaseClass<OppdragLeverandor> {

  tabName(): Tabs {
    return Tabs.oppdrag;
  }

  constructor(tabsService: TabsService, service: KoblingerService, tilgangService: TilgangService, route: ActivatedRoute, modal: ModalService, router: Router) {
    super(tabsService, service, tilgangService, modal, route, router);
  }

  loaderObservable(service: KoblingerService, id: number): Observable<OppdragLeverandor[]> {
    return service.getOppdragLeverandorRolleForLeverandor(id);
  }

  pageLinkAccess(service: TilgangService): Observable<boolean> {
    return service.getGlobalRoles().pipe(map(val => val.oppdrag.listAccess));
  }

  removeObservable(service: KoblingerService, item: OppdragLeverandor): Observable<object> {
    return service.removeOppdragLeverandorRolleForLeverandor(item.leverandorId, item.oppdragId, item.rolleId);
  }

  public static oppdragUtgatt(oppdragSystem: OppdragLeverandor) : boolean {
    return oppdragSystem.oppdrag.oppdragStatusId == 3;
  }

  compareFn(first: OppdragLeverandor, second: OppdragLeverandor): number {
    if (!LeverandorOppdragTabComponent.oppdragUtgatt(first) && !LeverandorOppdragTabComponent.oppdragUtgatt(second)) return 0;
    if (!LeverandorOppdragTabComponent.oppdragUtgatt(first) && LeverandorOppdragTabComponent.oppdragUtgatt(first)) return -1;
    else return 1;
  }

  kobleTil(): void {
    this.modal.velgOppdrag().then(oppdrag => {
      this.modal.velgLeverandorRolle().then(rolle => {

        if (this.liste.some(t => t.oppdragId === oppdrag.id && t.rolleId === rolle.rolleId)) {
          this.modal.warning(`${oppdrag.navn} med rolle ${rolle.navn} er allerede koblet til leverandør`, "Kobling feilet");
          return;
        }

        const op: OppdragLeverandor = { leverandorId: this.id, oppdragId: oppdrag.id, rolleId: rolle.rolleId };
        console.log(op);
        this.service.postOppdragLeverandorRolleForLeverandor(op).toPromise().then(() => {
          this.modal.success("Oppdrag koblet til leverandør og rolle", "Kobling vellykket");
          this.load();
        });
      });
    });
  }
}
